import { render, staticRenderFns } from "./jh.vue?vue&type=template&id=4a89dc66"
import script from "./jh.vue?vue&type=script&lang=js"
export * from "./jh.vue?vue&type=script&lang=js"
import style0 from "./jh.vue?vue&type=style&index=0&id=4a89dc66&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports